import { isNotNil } from "client/Misc/utils";
import { useCallback, useEffect } from "react";

export type AutoFocusState<TId> = {
	itemIdToFocus: TId | null;
	changeTo: (id: TId | null) => void;
};

export function useAutoFocus<TId>(
	itemId: TId,
	state: AutoFocusState<TId>
): [autoFocus: "focus" | undefined, doAutoFocus: () => void] {
	const { changeTo, itemIdToFocus } = state;

	const autoFocus: "focus" | undefined = itemIdToFocus === itemId
		? "focus"
		: undefined;

	useEffect(
		(): void => {
			if (isNotNil(autoFocus)) {
				changeTo(null);
			}
		},
		[autoFocus, changeTo]
	);

	const doAutoFocus = useCallback(
		(): void => {
			changeTo(itemId);
		},
		[itemId, changeTo]
	);

	return [autoFocus, doAutoFocus];
}